import React from "react";
import { useRouteMatch } from "react-router-dom";
const Nav = ({ to, activeOnlyWhenExact, label, children, special }) => {
  let match = useRouteMatch("/(casting-couch-hd|net-girl|net-video-girls)");
  return (
    <div className={match ? "item active" : "item"}>
      <span className={special ? special : ""}>
        <span className="justNav">{label}</span>
        {children}
      </span>
    </div>
  );
};

export default Nav;
